import { useLayoutEffect, useState } from 'react';

import { Box, Button, Link, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router';

import GoLogo from '@/components/GoLogo';
import { useAppDispatch } from '@/hooks/redux-hooks';
import DefaultLayout from '@/layouts/DefaultLayout';
import { useGxTokenFromStorage, useTripTokenFromStorage } from '@/services/storage';
import { logout } from '@/slices/authSlice';
import { clearSelection } from '@/slices/symbolSelectorSlice';

const Logout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tripToken = useTripTokenFromStorage();
  const gxToken = useGxTokenFromStorage();
  const [wasLoggedInOnMount] = useState(Boolean(gxToken || tripToken));

  useLayoutEffect(() => {
    if (wasLoggedInOnMount) {
      dispatch(clearSelection());
      dispatch(logout());
    }
  }, [wasLoggedInOnMount, dispatch]);

  if (!wasLoggedInOnMount) {
    return (
      <Navigate
        replace
        to='/login'
      />
    );
  }
  return (
    <DefaultLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          mt: '8%'
        }}
      >
        <GoLogo size={40} />
        <Typography sx={{ fontSize: 36, fontWeight: 700, mb: 2, mt: 4 }}>
          You've been logged out.
        </Typography>
        <Typography sx={{ fontSize: 24 }}>Please log back in.</Typography>
        <Button
          sx={{
            my: 4,
            fontSize: 18,
            width: 300
          }}
          variant='contained'
          onClick={() => {
            navigate('/login');
          }}
        >
          Go to Login
        </Button>
        <Typography sx={{ fontSize: 16 }}>
          Any issues? Drop us a line at{' '}
          <Link
            color='text.primary'
            href='mailto:support@general-index.com'
            target='_top'
          >
            support@general-index.com
          </Link>
        </Typography>
      </Box>
    </DefaultLayout>
  );
};

export default Logout;
